import { render, staticRenderFns } from "./ProfitClosing.vue?vue&type=template&id=c2b52812"
import script from "./ProfitClosing.vue?vue&type=script&lang=js"
export * from "./ProfitClosing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports